// prettier-ignore
// @ts-expect-error incompatibility with node16 resolution
import type { PortableTextBlock, PortableTextMarkDefinition } from '@portabletext/types';
import clsx from 'clsx';
import {motion} from 'framer-motion';
import {useState} from 'react';

type Props = PortableTextBlock & {
  mark: PortableTextMarkDefinition & {
    subject: string;
  };
};

const EmbedForm = (props: Props) => {
  const {children, mark} = props;
  const {subject} = mark;
  const host = import.meta.env.PUBLIC_FUNCTION_HOST;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [submitted, setSubmitted] = useState<boolean>(false);

  return (
    <>
      <div
        onClick={() => setIsOpen((prev) => !prev)}
        className="cursor-pointer !text-orange no-underline"
      >
        <>{children}</>
      </div>

      <motion.div
        initial={{height: 0}}
        animate={isOpen ? {height: 'auto'} : {height: 0}}
        className="relative overflow-hidden"
      >
        <form
          className={clsx([
            'transition-standard relative py-10',
            submitted && 'pointer-events-none opacity-0',
          ])}
          onSubmit={(e) => {
            e.preventDefault();
            fetch(`${host}/embedForm`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: JSON.stringify({
                name: e.target.subject?.value,
                email: e.target.email?.value,
              }),
            }).then(() => {
              setSubmitted(true);
            });
          }}
        >
          <label htmlFor="email" className="block pb-4">
            Enter your email to confirm your identity
          </label>
          <input
            name="subject"
            value={subject}
            className="pointer-events-none invisible absolute"
          />
          <input
            name="email"
            id="email"
            className="input-standard block w-full focus:border-0 focus:outline-0 focus:ring-0"
            placeholder="example@example.com"
          />
          <button
            type="submit"
            className="btn-sm mt-5"
            onClick={() => setSubmitted(true)}
          >
            Submit
          </button>
        </form>
        <div
          className={clsx([
            'richH6 transition-standard absolute inset-0 py-10',
            !submitted && 'pointer-events-none opacity-0',
          ])}
        >
          Thank you, your request has been received.
        </div>
      </motion.div>
    </>
  );
};

export default EmbedForm;
